import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
Date.prototype.format = Date.prototype.format || function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "D+": this.getDate(), //日 
        "d+": this.getDate(), //日 
        "H+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/i.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};
window._sui_webpack_remote_path = window._sui_webpack_remote_path || '';
const _get_sui_webpack_remote_time = new Date().getTime();
window._get_sui_webpack_remote_url = window._get_sui_webpack_remote_url || function(name, host, ver, fileName) {
    fileName = fileName || "remoteEntry.js?_tt=" + _get_sui_webpack_remote_time;
    var path =  ((window._sui_webpack_remote_urls || {})[name]) || "";
    var verPath = ver ? ("/" + ver) : "";
    if ( !path ) {
        var remote_path  = window._sui_webpack_remote_path
        if ( remote_path && !host ) {
            host = remote_path.replace(/[\\/]+$/i, "") + '/' + name
        }
        host = host.replace(/[\\/]+$/i, "")
        path = host + verPath + "/" + fileName;
    } else {
        path = path.replace("/:ver", verPath);
    }
    return path;
}